export default function ChevronUp() {
    return (
        <svg>
            <use xlinkHref="#chevron-up" />
        </svg>
    );
}
